import * as React from 'react';

import useTheme from 'hooks/useTheme';

interface Props extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
    lightSrc: string;
    darkSrc: string;
    alt: string;
}

const ThemedImage: React.FC<Props> = ({ lightSrc, darkSrc, alt, ...props }) => {
    const { theme } = useTheme();

    return <img {...props} src={theme === 'dark' ? darkSrc : lightSrc} alt={alt} />;
};

export default ThemedImage;
